import FigmaDimensionsIcon from './FigmaDimensionsIcon';

interface Properties {
  width?: number;
  height?: number;
}

const DimensionsIconActive = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaDimensionsIcon width={width} height={height} color='#FFFFFF' />;
};

export default DimensionsIconActive;
